export var quoteArr = [
  ["Be yourself; everyone else is already taken.", "Oscar Wilde"],

  [
    "Two things are infinite: the universe and human stupidity; and I'm not sure about the universe.",
    "Albert Einstein",
  ],

  ["So many books, so little time.", "Frank Zappa"],

  [
    "You know you're in love when you can't fall asleep because reality is finally better than your dreams.",
    "Dr. Seuss",
  ],

  ["You only live once, but if you do it right, once is enough.", "Mae West"],

  ["Be the change that you wish to see in the world.", "Mahatma Gandhi"],

  ["If you tell the truth, you don't have to remember anything.", "Mark Twain"],

  ["Without music, life would be a mistake.", "Friedrich Nietzsche"],

  [
    "Some day you will be old enough to start reading fairy tales again.",
    "C.S. Lewis",
  ],

  [
    "It’s no use going back to yesterday, because I was a different person then.",
    "Lewis Carroll",
  ],

  ["Books are a uniquely portable magic.", "Stephen King"],

  [
    "Nothing is impossible, the word itself says I'm possible'!",
    "Audrey Hepburn",
  ],

  ["Life’s a garden. Dig it", "Joe Dirt"],

  [
    "Why do we fall? So we can learn to pick ourselves back up",
    "Alfred Pennyworth",
  ],

  ["Sometimes, I believe we sort too young...", "Albus Dumbledore"],

  ["I Solemnly Swear I'm Up to No Good", "Harry Potter"],

  ["D'oh!", "Homer Simpson"],
];
